import { cn } from '../cn.ts';
import type { MockTint } from './types.ts';

export interface MockAvatarProps {
  readonly initials: string;
  readonly tint: MockTint;
  /**
   * Hai cỡ ĐO ĐƯỢC: 30px cho avatar người trong bong bóng chat (`template.html:686`), 18px cho ô
   * chữ cái của agent trong sidebar (`:668`).
   *
   * Là PROP chứ không phải class đè qua `className`: `cn()` chỉ nối chuỗi, nên `size-[30px]` của
   * component và `size-[18px]` của chỗ dùng cùng tồn tại, thắng thua do thứ tự Tailwind xếp trong
   * CSS. Đo được: ô agent render 30px thay vì 18px, đẩy chữ lệch 12px và làm hàng cao thêm.
   */
  readonly size?: 30 | 18;
  readonly className?: string;
}

const SIZE = {
  30: 'size-[30px] rounded-pill text-micro',
  18: 'size-[18px] rounded-tile text-nano',
} as const;

/** 4 cặp tint đo từ thiết kế (`reference.md` §3 "avatar") — không sinh cặp thứ 5. */
const TINT = {
  brand: 'bg-brand-50 text-brand-600',
  success: 'bg-success-bg text-success-fg',
  warn: 'bg-warn-bg text-warn-fg',
  violet: 'bg-violet-bg text-violet-fg',
} as const;

export function MockAvatar({ initials, tint, size = 30, className }: MockAvatarProps) {
  return (
    <span
      className={cn(
        'grid flex-none place-items-center font-bold',
        SIZE[size],
        TINT[tint],
        className,
      )}
    >
      {initials}
    </span>
  );
}
